<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div>
          <a-input class="inp ml24" placeholder="请输入公告关键字" v-model:value="query.title"></a-input>
        </div>

        <a-select v-model:value="query.status" placeholder="请选择状态" class="ml30 status-select">
          <a-select-option value=''>全部</a-select-option>
          <a-select-option value='1'>已发布</a-select-option>
          <a-select-option value='0'>草稿</a-select-option>
          <a-select-option value='2'>已下架</a-select-option>
        </a-select>

        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
      <div class="search-r">
        <a-button class="ml30" @click="add" type="primary">+ 新建</a-button>
        <a-button class="ml30" type="primary" @click="router.push('/home/manage')"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
      </div>
    </div>

    <!-- 公告列表 - 改为Table实现 -->
    <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        :data-source="dataSource"
        class="mt23"
        size="middle"
        :pagination="pagination"
        :scroll="{ y: 'auto' }"
        v-autoHeight="{ extraHeight: 88, trHeight: 47 }"
    >
      <template #bodyCell="{ column, record, index }">
        <!-- 注意这里增加了 index 参数 -->
        <template v-if="column.key === 'index'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'title'">
          <!-- 为标题添加样式类 -->
          <span class="announcement-title" @click="viewAnnouncement(record.id)">{{ record.title }}</span>
        </template>
        <template v-if="column.key === 'content'">
          <div class="announcement-content" v-html="formatContent(record.content)"></div>
        </template>
        <template v-if="column.key === 'publishDate'">
          {{ formatDate(record.publishDate) }}
        </template>
        <template v-if="column.key === 'status'">
          <span class="status-tag" :class="getStatusClass(record.status)">{{ getStatusText(record.status) }}</span>
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a @click="viewAnnouncement(record.id)">查看详情</a>
            <a class="ml10" @click="editAnnouncement(record)">修改</a>
            <a v-if="record.status === 0 || record.status === 2" class="ml10" @click="publishAnnouncement(record.id)">发布</a>
            <a v-else-if="record.status === 1" class="ml10" @click="disableAnnouncement(record.id)">下架</a>
            <a class="ml10" @click="delAnnouncement(record)">删除</a>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { message, Modal } from 'ant-design-vue'
import { getPagesByCondition, updateStatus, del } from "@/api/announcement/index.js";
import useUserStore from '@/store/modules/user'
import request from '@/utils/request';

const router = useRouter();
const store = useUserStore();

const addModalVisible = ref(false);
const editModalVisible = ref(false);
const currentAnnouncement = ref({});

let dataSource = ref([]);
let query = reactive({
  title: '',
  status: null
});

// 表格列定义
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    fixed: 'left',
    width: 50
  },
  {
    title: "公告标题",
    dataIndex: "title",
    key: "title",
    ellipsis: true,
    width: 270
  },
  {
    title: "公告内容",
    dataIndex: "content",
    key: "content",
    ellipsis: true,
    width: 320
  },
  {
    title: "发布时间",
    dataIndex: "publishDate",
    key: "publishDate",
    width: 150
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    width: 60
  },
  {
    title: "操作",
    key: "action",
    fixed: 'right',
    width: 140
  },
];

const pageChange = (page, pageSize) => {
  pagination.current = page;
  getData();
}

const pageSizeChange = (current, size) => {
  pagination.pageSize = size;
  getData();
}

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.title = "";
  query.status = "";
  pagination.current = 1;
  getData();
};

const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query, deptId: store.deptId },
  };
  getPagesByCondition(data).then((res) => {
    if (res.code === 200) {
      dataSource.value = res.data.records || [];
      pagination.total = res.data.total;
    }
  });
};

// 格式化日期
const formatDate = (dateString) =>{
  if (!dateString) return '';
  // 简单的日期格式化，实际项目中可能需要更复杂的处理
  return dateString;
}

// 格式化内容，去除HTML标签并限制长度
const formatContent = (content) => {
  if (!content) return '';
  // 移除HTML标签
  const plainText = content.replace(/<[^>]*>/g, '');
  // 限制显示长度
  return plainText.length > 100 ? plainText.substring(0, 100) + '...' : plainText;
}

// 获取状态文本
const getStatusText = (status) => {
  const statusMap = {
    0: '草稿',
    1: '已发布',
    2: '已下架'
  };
  return statusMap[status] || '未知状态';
}

// 获取状态样式类
const getStatusClass = (status) => {
  const statusClassMap = {
    0: 'status-draft',
    1: 'status-published',
    2: 'status-disabled'
  };
  return statusClassMap[status] || '';
}

// 查看详情
const viewAnnouncement = (id) => {
  router.push({ path: '/announcement/detail', query: { id: id } });
}

// 打开新增公告页面
const add = () => {
  router.push('/announcement/edit');
};

// 打开编辑公告页面
const editAnnouncement = (item) => {
  router.push({
    path: '/announcement/edit',
    query: { id: item.id }
  });
};

// 删除
const delAnnouncement = async (item) => {
  try {
    const res = await del(item.id);

    if (res.code === 200) {
      message.success('公告删除成功');
      getData();
    } else {
      message.error(res.message || '公告删除失败');
    }
  } catch (error) {
    message.error('操作失败，请重试');
    console.error('删除公告出错:', error);
  }
};

// 发布公告
const publishAnnouncement = async (id) => {
  Modal.confirm({
    title: '确定要发布该公告吗？',
    content: '发布后，公告将对所有用户可见。',
    okText: '确定',
    okType: 'primary',
    cancelText: '取消',
    async onOk() {
      try {
        const data = {
          id: id,
          status: 1
        };
        const res = await updateStatus(data);

        if (res.code === 200) {
          message.success('公告发布成功');
          getData();
        } else {
          message.error(res.message || '公告发布失败');
        }
      } catch (error) {
        message.error('操作失败，请重试');
        console.error('发布公告出错:', error);
      }
    }
  });
}

// 下架公告
const disableAnnouncement = async (id) => {
  Modal.confirm({
    title: '确定要下架该公告吗？',
    content: '下架后，用户将无法在前台查看该公告。',
    okText: '确定',
    okType: 'primary',
    cancelText: '取消',
    async onOk() {
      try {
        const data = {
          id: id,
          status: 2
        };
        const res = await updateStatus(data);
        if (res.code === 200) {
          message.success('公告下架成功');
          getData();
        } else {
          message.error(res.message || '公告下架失败');
        }
      } catch (error) {
        message.error('操作失败，请重试');
        console.error('下架公告出错:', error);
      }
    }
  });
}

onMounted(async () => {
  getData();
});

</script>

<style lang="less" scoped>
.inp {
  width: 25vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }

  .status-select {
    width: 120px;
  }
}

.main {
  padding: 20px;
  min-height: calc(100vh - 70px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

/deep/.ant-table-wrapper .ant-table.ant-table-middle .ant-table-tbody>tr>td {
  height: 90px;
}

.status-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;

  &.status-draft {
    background-color: #f5f5f5;
    color: #86909c;
  }

  &.status-published {
    background-color: #f0f9ff;
    color: #1890ff;
  }

  &.status-disabled {
    background-color: #fff2f0;
    color: #ff4d4f;
  }
}

.announcement-title {
  color: #2c3e50;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.announcement-content {
  font-size: 14px;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

a {
  color: #1E8EF2;
}


</style>